export const TOOL_COLORS = [
    { color: '#DC143C', name: 'Red' },
    { color: '#FF6B35', name: 'Orange' },
    { color: '#FFD700', name: 'Yellow' },
    { color: '#32CD32', name: 'Green' },
    { color: '#00CED1', name: 'Cyan' },
    { color: '#1E90FF', name: 'Blue' },
    { color: '#9370DB', name: 'Purple' },
    { color: '#FF69B4', name: 'Pink' },
    { color: '#FFFFFF', name: 'White' },
    { color: '#000000', name: 'Black' },
];
export const DEFAULT_COLOR = '#DC143C';
